import { type ApolloError, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type PanelSummaryData } from '../../../GSAssessment';
import { type PartnerSummaryTableData } from '../../../GSAssessment/components/GSPanelDetails/components/PanelListTableCells/PanelPartnerSummaryTable';

const GET_PANEL_INFORMATION = gql`
  query ($panelId: ID!, $filter: PanelApplicationFilter) {
    panelSummaryTable(panelId: $panelId, filter: $filter) {
      totalStudentshipYears
      faculties {
        abbr
        name
        total
        filtered
        studentshipYears
        departments {
          abbr
          name
          facultyAbbr
          facultyName
          total
          filtered
          studentshipYears
        }
      }
      partners {
        partnerUniversity
        partnerUniversityName
        total
        filtered
        studentshipYears
      }
    }
  }
`;

export const useGetPanelSummaryTable = (
  panelId: string,
  filter: any,
): {
  panelSummary: PanelSummaryData[];
  partnerSummary: PartnerSummaryTableData[];
  totalStudentshipYears: number;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
} => {
  const { data, loading, error, refetch } = useQuery(GET_PANEL_INFORMATION, {
    variables: { panelId, filter },
    fetchPolicy: 'network-only',
    skip: !panelId,
  });
  const panelSummary: PanelSummaryData[] =
    data?.panelSummaryTable?.faculties ?? [];
  const partnerSummary: PartnerSummaryTableData[] =
    data?.panelSummaryTable?.partners ?? [];

  const totalStudentshipYears =
    data?.panelSummaryTable?.totalStudentshipYears ?? 0;

  return {
    panelSummary,
    partnerSummary,
    totalStudentshipYears,
    loading,
    error,
    refetch,
  };
};
